import Vue from 'vue';
import store from '@/store';

export default function show({ text, color }) {
  store.dispatch('snackbar/setShow', { show: false });
  Vue.nextTick(() => {
    store.dispatch('snackbar/setColor', { color });
    store.dispatch('snackbar/setText', { text });
    store.dispatch('snackbar/setShow', { show: true });
  });
}
